module.exports = __webpack_public_path__ + "static/media/rising_star_white.1a4782bc.svg";